// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SQ-popup-conent {
  padding: 24px;
  height: calc(100vh - 200px);
}
.SQ-popup-conent h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #2D388B;
}
.SQ-popup-conent p {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  color: #1F2937;
  margin-bottom: 20px;
}

/* Add this to your component's CSS or the global stylesheet */
.status-button {
  display: inline-flex;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #000;
}

.status-button:hover {
  background-color: #e0e0e0;
  cursor: pointer;
}

.status-button span {
  margin-left: 4px; /* Adjust the space between the circle icon and text */
}

.gc-agency-handle {
  display: block;
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  color: rgba(75, 85, 99, 0.5);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
